import { useState } from "react";

/**
 * Manages local input state with validation.
 * The parent's `onChange` only fires when the value passes `validate`.
 * Returns props that can be spread onto a text field.
 */
export const useValidatedInput = (
  value: string,
  onChange: (v: string) => void,
  validate: (v: string) => boolean
) => {
  const [localValue, setLocalValue] = useState(value);
  const isValid = validate(localValue);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const v = e.target.value;
    setLocalValue(v);
    if (validate(v)) {
      onChange(v);
    }
  };

  return {
    value: localValue,
    onChange: handleChange,
    error: !isValid,
  };
};
